/**
 * Typewriter Animation for MV Title
 * タイトルを1文字ずつ表示するアニメーション
 */

class TypewriterAnimation {
  constructor() {
    this.titleElement = document.querySelector('.p-mv__title');
    this.delay = 0; // 全体の開始遅延
    this.charDelay = 80; // 文字間の遅延（ミリ秒）

    if (this.titleElement) {
      this.init();
    }
  }

  init() {
    // 初期状態で全体を非表示にする
    this.hideTitle();

    // タイトルエリアの表示を待ってからタイプライター開始
    setTimeout(() => {
      this.startTypewriter();
    }, 1300); // fadeInアニメーション後に開始
  }

  hideTitle() {
    // 各span要素を非表示にする
    const spans = this.titleElement.querySelectorAll('span');
    spans.forEach(span => {
      span.style.opacity = '0';
    });
  }

  startTypewriter() {
    const spans = this.titleElement.querySelectorAll('span');
    let globalCharIndex = 0;

    spans.forEach((span, spanIndex) => {
      const text = span.textContent;
      span.textContent = ''; // 一旦空にする
      span.style.opacity = '1'; // spanを表示

      // 各文字を個別のspanで包む
      for (let i = 0; i < text.length; i++) {
        const char = text[i];
        const charSpan = document.createElement('span');
        charSpan.textContent = char;
        charSpan.classList.add('typewriter-char');
        charSpan.style.opacity = '0';

        // 文字を順次表示
        setTimeout(() => {
          charSpan.style.opacity = '1';
        }, globalCharIndex * this.charDelay);

        span.appendChild(charSpan);
        globalCharIndex++;
      }

      // 最初のspan（断られる営業は、もう終わり）の装飾要素を最後に表示
      if (spanIndex === 0) {
        const decorationDelay = globalCharIndex * this.charDelay + 200;
        setTimeout(() => {
          span.classList.add('show-decorations');
        }, decorationDelay);
      }

      // スパン間に少し長めの間隔を追加
      if (spanIndex < spans.length - 1) {
        globalCharIndex += 3; // 240ms余分な間隔
      }
    });
  }
}

// DOM読み込み完了後に初期化
document.addEventListener('DOMContentLoaded', () => {
  new TypewriterAnimation();
});